import { createReducer } from 'redux/shelf';
import { get, post, put } from 'redux/shelf/api';
import session from 'lib/session';

export const actions = {
  downgrade: put`downgrade`(),
  upgrade: put`upgrade`(),
  submitContact: post`/contact-us`(),
}

export const reducer = createReducer();
